import React, { useState, useEffect } from "react";
import history from "../../managers/history";
import Banner from "../../common/components/banner";
import { useForm } from "react-hook-form";
import {
  failureMessageConstant,
  regexConstant,
  successMessageConstant
} from "../../constants";
import PropTypes from "prop-types";
import { Loader } from "../../common/components/loader";
const { EMAIL_REQUIRED, INVALID_EMAIL } = failureMessageConstant;

const ResetPasswordComponent = (props) => {
  const states = props?.states;
  const functionObj = props?.functionObj;
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm();
  const [componentHeight, setComponentHeight] = useState(window.innerHeight);

  const updateComponentHeight = () => {
    setComponentHeight(window.innerHeight);
  };

  useEffect(() => {
    updateComponentHeight();
    window.addEventListener("resize", updateComponentHeight);
    return () => {
      window.removeEventListener("resize", updateComponentHeight);
    };
  }, []);

  return (
    <div
      className="flex lg:overflow-hidden "
      style={{ height: componentHeight }}
    >
      <div className="flex w-full flex-col overflow-y-auto bg-white px-5 md:w-1/2 ">
        <div className="flex pl-2 pt-3">
          <img alt="logo" className="z-10" src="/images/datasent-logo.svg" />
        </div>
        <div className="my-auto w-full pb-4 md:mx-auto md:max-w-89">
          <div className="flex font-MontserratSemiBold text-ft24 ">
            Reset Your Password Here
          </div>
          <form onSubmit={handleSubmit(functionObj?.submitHandler)}>
            <div className="pt-9">
              {states?.showSuccessMsg && (
                <div className="mb-5 rounded bg-green-10 pb-13px pl-3 pt-3.5 font-MontserratRegular text-ft14-17.02-0.28 text-white">
                  {successMessageConstant.PASSWORD_RESET_MAIL_SENT}
                </div>
              )}
              <div className="font-PoppinsMedium text-ft15-18.29-0.3">
                Registered Email
              </div>
              <div className="mb-9 mt-11px">
                <input
                  id="email"
                  name="email"
                  placeholder="admin@gmail.com"
                  autoComplete="email"
                  className={`relative flex h-49px w-full rounded border ${errors?.email || states?.emailError ? "border-red-10" : "border-grey-C7C7C7"} px-4 py-2 font-MontserratRegular text-ft15 outline-none `}
                  {...register("email", {
                    required: EMAIL_REQUIRED,
                    pattern: {
                      value: regexConstant.EMAIL_REGEX,
                      message: INVALID_EMAIL
                    }
                  })}
                  onChange={() => {
                    functionObj?.updateState("emailError", "");
                  }}
                />
                {(errors?.email || states?.emailError) && (
                  <div className="mt-2 flex items-center gap-5px font-MontserratRegular text-ft13-15.85-0.26 text-red-10">
                    <img src="/images/info-circle.svg" alt="info"></img>
                    <p>{errors?.email?.message || states?.emailError}</p>
                  </div>
                )}
              </div>
              <button className="flex h-49px w-full items-center justify-center rounded bg-purple-6C36B0 font-MontserratMedium text-ft15 text-white ">
                {states?.isLoading ? <Loader /> : "Reset Password"}
              </button>
              <div className="mt-8 flex items-center justify-start font-MontserratRegular">
                <div className="flex justify-end text-ft15 text-black-20">
                  Return to
                  <div
                    onClick={() => history.push("/")}
                    className="ml-1 cursor-pointer text-ft15 text-blue-726FFF "
                  >
                    Sign in
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <Banner />
    </div>
  );
};
ResetPasswordComponent.propTypes = {
  states: PropTypes.shape({
    title: PropTypes.string.isRequired,
    buttonText: PropTypes.string.isRequiredy
  }).isRequired,
  functionObj: PropTypes.shape({
    handleClick: PropTypes.func.isRequired
  }).isRequired
};
export default ResetPasswordComponent;
